"use client"

import { createContext, useContext, type ReactNode } from "react"
import type { InsurerLogo } from "@/components/ui/insurer-marquee-section"

/**
 * The market's supplementary insurers, resolved once in
 * `[country]/[locale]/layout.tsx` alongside its other CMS reads, for the
 * insurance section every main page of the membership-first site shows
 * (`InsuranceSection`). Empty everywhere else: only that site reads it.
 */
const InsurersContext = createContext<InsurerLogo[]>([])

export function InsurersProvider({
  value,
  children,
}: {
  value: InsurerLogo[]
  children: ReactNode
}) {
  return (
    <InsurersContext.Provider value={value}>
      {children}
    </InsurersContext.Provider>
  )
}

export function useInsurers(): InsurerLogo[] {
  return useContext(InsurersContext)
}
